import request from '@/utils/request'

export const getCustomerPackagingRequirements = (params) =>
  request({ url: '/api/customer-packaging-requirements', method: 'get', params })

export const getCustomerPackagingRequirementsResolveMap = () =>
  request({ url: '/api/customer-packaging-requirements/resolve-map', method: 'get' })

export const createCustomerPackagingRequirement = (data) =>
  request({ url: '/api/customer-packaging-requirements', method: 'post', data })

export const updateCustomerPackagingRequirement = (requirementId, data) =>
  request({ url: `/api/customer-packaging-requirements/${requirementId}`, method: 'put', data })

export const deleteCustomerPackagingRequirement = (requirementId) =>
  request({ url: `/api/customer-packaging-requirements/${requirementId}`, method: 'delete' })
